import type { RouteRecordRaw } from "vue-router";
import VersionControl from "@/views/VersionControl.vue";
import VersionList from "@/components/VersionControl/VersionList.vue";
import ReconVersion from "@/components/VersionControl/ReconVersion.vue";
import BaseBuild from "@/components/VersionControl/BaseBuild.vue";
import { set_default_pagination } from "./util";

export const version_routes: RouteRecordRaw = {
  path: "/version",
  component: VersionControl,
  name: "VersionControl",
  beforeEnter: set_default_pagination,
  redirect: { name: "VersionList" },
  children: [
    {
      path: "list",
      component: VersionList,
      name: "VersionList",
    },
    {
      path: "recon",
      component: ReconVersion,
      name: "VersionRecon",
    },
    {
      path: "base_build",
      component: BaseBuild,
      name: "VersionBaseBuild",
    },
  ],
};
